import { noUsersSaysVideoLocales } from '@elem/compPage/a-new-era-of-cool/config/pageConfig';
import EcoSpace from 'eco-design/base/eco-space';
import EcoSpaceSmall from 'eco-design/base/eco-space-small';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import { useRouter } from 'next/router';
import EcoImg from 'eco-design/base/eco-img';

import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function Comp() {
    const { t } = useLang('theProduct.BackupSystemSection');
    const { locale } = useRouter();

    return (
        <div className={`${styles.comp}`}>
            <EcoSectionCommon label={t('label')} title={t('title')} labelColor="#3F68E0" />
            <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1750212578576/backup_system_1.jpg" />
        </div>
    );
}
